import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nbi-confirm-dialog-wrapper"
};
const _hoisted_2 = {
  class: "nbi-confirm-dialog-content"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "nbi-ctrl-bar flex flex-ac flex-jc-end"
};
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

import { computed } from 'vue';
export default /*@__PURE__*/Object.assign({
  name: 'NbiConfirmDialog'
}, {
  __name: 'confirmDialog',
  props: {
    /**
     * 通用文案类型 0
     * AI分身批量添加文案类型 1
     */
    messageType: {
      type: Number,
      default: 0
    },
    /**
     * 本次需消耗的牛币数量
     */
    needPayNum: {
      type: Number,
      default: 0
    },
    /**
     * 剩余的牛币数量
     */
    remainingNum: {
      type: Number,
      default: 0
    }
  },
  emits: ['close', 'success'],
  setup(__props, _ref) {
    let __emit = _ref.emit;
    const _useI18n = useI18n(),
      $t = _useI18n.t;
    const store = useStore();
    const props = __props;
    const message = computed(() => {
      const messageMap = {
        0: $t('member.payment.nbiInsufficientTip', {
          needPayNum: props.needPayNum,
          remainingNum: props.remainingNum
        }),
        1: $t('member.payment.avatarBatchInsufficientTip', {
          remainingNum: props.remainingNum
        })
      };
      return messageMap[props.messageType];
    });
    const emit = __emit;
    const onHandleConfirm = () => {
      emit('close');
      store.commit('setNbiRechargeDialog', {
        visible: true,
        onSuccess: () => {
          console.log('onSuccess');
          emit('success');
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", {
        innerHTML: _unref(message)
      }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "cancel-btn",
        onClick: _cache[0] || (_cache[0] = $event => emit('close'))
      }, _toDisplayString(_unref($t)('common.button.cancel')), 1), _createElementVNode("div", {
        class: "confirm-btn",
        onClick: onHandleConfirm
      }, _toDisplayString(_unref($t)('member.payment.getNbi')), 1)])]);
    };
  }
});